import RibbonBannerDynamicText from './ribbon-banner-dynamic-text';

document.addEventListener('DOMContentLoaded', () => {
  // do your setup here
  console.log('Initialized app init ! ');
  const rb = new RibbonBannerDynamicText();
  const range = new Range();

});
